'use client'

import { useEffect } from "react";

export const setCookie = (mboxCookie: string) => {
    if (!mboxCookie) return;
    if (typeof document === 'undefined') return;

    window.document.cookie = `mbox=${mboxCookie};path=/;domain=.webmotors.com.br;`;
    return;
}

export const getCookie = (name: string) => {
    if (typeof document === 'undefined') return null;
    const match = window?.document?.cookie?.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
}

export const CookieComponent = ({ mbox }: { mbox: string }) => {
    useEffect(() => {
        if (!mbox) return;

        const current = getCookie('mbox');
        if (current !== mbox) {
            setCookie(mbox);
        }
    }, [mbox]);
    return null;
}